module.exports = __webpack_public_path__ + "static/media/2BIANCA_Official_MENU-.2557c201.jpg";